/**
 * Formats a number as an MXN currency string (e.g. "$9,314.00", "-$354.00").
 *
 * Shared by mappers (infrastructure) and presentation components so the
 * subscription domain has a single source of truth for money formatting.
 *
 * Negative amounts render with the minus sign before the currency symbol
 * (e.g. "-$354.00") instead of "$-354.00".
 *
 * @param amount - Numeric amount
 * @returns Formatted string like "$9,314.00" or "-$354.00"
 */
export const formatCurrencyMXN = (amount: number): string => {
  const absoluteFormatted = Math.abs(amount).toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return amount < 0 ? `-$${absoluteFormatted}` : `$${absoluteFormatted}`;
};
